import React from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { Control } from '@/components/form';
import Loading from '@/components/loading/Loading';

interface NewCardProps {
  name: string;
  value?: string;
  label: string;
  error?: string;
  isFailed: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPaymentElementChange: (complete: boolean) => void;
}

const NewCard = ({
  name,
  value,
  label,
  error,
  isFailed,
  onChange,
  onPaymentElementChange,
}: NewCardProps) => {
  const stripe = useStripe();
  const elements = useElements();

  const isLoading = !stripe || !elements;
  return isLoading ? (
    <Loading />
  ) : (
    <div className='NewCard'>
      {/* @ts-expect-error: wrong types */}
      <Control
        onChange={onChange}
        label={label}
        as='input'
        type='text'
        name={name}
        value={value}
        isFailed={isFailed}
        validationError={error}
      />
      <PaymentElement
        onChange={(elementProps) =>
          onPaymentElementChange(elementProps.complete)
        }
        options={{
          fields: {
            billingDetails: {
              address: {
                country: 'never',
              },
            },
          },
        }}
      />
    </div>
  );
};

export default NewCard;
